module.exports = __webpack_public_path__ + "img/base_nature_montagne.c19e931b.svg";